/*
* Common JS library for interacting with Restricted Features.
*
* Example:
* ButtonA in the faculty memo which appears on every faculty page and
* ButtonB somewhere else. Clicking either button will enable a restricted
* feature for the user and then perform some other actions depending on
* which button was clicked.
*    <button id="ButtonA" onclick="optMeIn(); navigateToNewFeature();" />
*    <button id="ButtonB" onclick="optMeIn(); refreshThePage();" />
* In this case, having the function optMeIn() in this library allows both
* buttons to use the same logic for toggling the feature from any page in
* WA or v4 without sacrificing onclick autonomy.
*
*/

interface IUserFeatureSetting {
    userId: number;
    featureName: string;
    enabled: string; 
}

export const setUserFeatureSetting = async (userFeatureSetting: IUserFeatureSetting) => {

    return fetch('/web/restricted-features/user-settings', {
        method: 'PUT',
        headers: {
            'Content-Type': 'application/json;charset=UTF-8',
            accept: 'application/json',
            'X-CSRF-TOKEN': document.querySelector('meta[name="X-CSRF-TOKEN"]')?.getAttribute('content')
        },
        body: JSON.stringify(userFeatureSetting),
        mode: 'cors',
        cache: 'no-cache',
    });
};

export const setUserFeatureSettingAndNavigate = async (userFeatureSetting: IUserFeatureSetting, url: string) => {
    await setUserFeatureSetting(userFeatureSetting);
    window.location.assign(url);
};
